/**
 * Foreground push: optional logging only. Navigation runs on notification tap via
 * pushNotificationService → navigateFromNotificationWithFallback.
 */
import { useEffect } from 'react';

export const usePushNotificationNavigation = (): void => {
  useEffect(() => {
    const handlePushNotification = (event: CustomEvent) => {
      const { data } = event.detail;
      if (data) {
        console.log('Foreground push received (no auto-nav; tap handled separately):', data);
      }
    };

    window.addEventListener('pushNotificationReceived', handlePushNotification as EventListener);
    return () => {
      window.removeEventListener('pushNotificationReceived', handlePushNotification as EventListener);
    };
  }, []);
};
